module.exports = __webpack_public_path__ + "static/media/sci-logo-light.b31fca38.svg";